import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, FormField, List, Popover, RadioGroup, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAccountOutline, mdiLocationEnter, mdiLocationExit, mdiMenuLeft, mdiMenuRight, mdiTrophyOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import { addMonths, format, parse } from 'date-fns';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemShift } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


type ItemUserShift = {
  idUser: number,
  orden: number,
  displayName: string,
  dateGroup: string
}

export const MembersMercenariesShiftsPage = () => {
  //const storeAdmin = useStoreAdmin();

  useGlobalState();
  const { navigate } = useRouter();

  const { idUser, menu, data } = useGlobalState();


  const [shifts, setShifts] = useState<ItemShift[]>([]);
  const [users, setUsers] = useState<ItemUserShift[]>([]);
  const [filter, setFilter] = useState<string>('0');

  const handleGetMercenaryUsers = async () => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/mercenaries/shifts/users',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({}),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(dataWeb, setData);
      if (dataWeb.code == 0) {
        setUsers(dataWeb.users);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }


  }
  const handleRegisterMercenary = async (add: boolean, idShift: number) => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/mercenaries/shifts/subscribe',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(
          {
            jsonExchange: true,
            idShift: idShift,
            add: add ? 1 : 0,
            shift: "DIR",
            isSelling: "",
            start: format(addMonths(new Date(), -3), 'dd-MM-yyyy'),
            orderBy: "dateShift",
            order: "desc",
          }
        ),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(dataWeb, setData);
      if (dataWeb.shifts) {
        setShifts(dataWeb.shifts);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }


  }
  const handleGetShifts = async () => {
    //if (parameters.startDate && parameters.endDate) { 

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/shifts/list',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(
          {
            jsonExchange: true,
            shift: "DIR",
            isSelling: "",
            start: format(addMonths(new Date(), -6), 'dd-MM-yyyy'),
            orderBy: "dateShift",
            order: "desc",
          }
        ),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();

      addNotificationStatus(dataWeb, setData);
      if (dataWeb.code == 0) {
        setShifts(dataWeb.shifts);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }

  }

  const filteredShifts = shifts.filter((item) => {
    return filter === '1' ? item.isSelling === 1 : true;
  });
  console.log("-----------------------")
  console.log(filteredShifts)
  console.log(shifts)

  useEffect(() => {
    handleGetShifts();
  }, []);
  const showRegisterColumn = filteredShifts.some(s => s.isSelling === 1);
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1"
            description={users && users.length === 0 ? `Listado de turnos rematados por vía mercenarios desde el ${format(addMonths(new Date(), -6), 'dd-MM-yyyy')}` : "Listado de prioridades de postulación de mercenarios para los turnos rematados"}
            actions={<SpaceBetween direction='horizontal' size='xs'>
              {
                users && users.length === 0 ?
                  <Button onClick={() => {
                    handleGetMercenaryUsers()
                    setUsers([])
                    setShifts([])
                  }}>Ver usuarios</Button> :
                  <Button onClick={() => {
                    setUsers([]);
                    setShifts([])
                    handleGetShifts();
                  }}>Ver turnos</Button>}
              <Favorites />
            </SpaceBetween>}>Turnos</Header>
          {users && users.length > 0 && (
            <Table
              empty={
                <Box
                  margin={{ vertical: "xs" }}
                  textAlign="center"
                  color="inherit"
                >Sin turnos registrados
                </Box>
              }
              sortingDisabled
              columnDefinitions={[
                {
                  id: 'order',
                  header: 'Orden',
                  cell: (item) => <Box textAlign='center'>{item.idUser === idUser ? <BadgeCustom size="large" color='blue'><Icon path={mdiMenuRight} size={1} /> {item.orden} <Icon path={mdiMenuLeft} size={1} /></BadgeCustom> : item.orden}</Box>,
                  width: 70,
                },
                {
                  id: 'displayName',
                  header: 'Usuario',
                  cell: (item) => item.idUser === idUser ? <strong>{item.displayName}</strong> : item.displayName,
                },
                {
                  id: 'dateGroup',
                  header: 'Última postulación',
                  cell: (item) => item.dateGroup,
                  width: 120,
                },
              ]}
              items={users}
              stickyHeader
              variant="embedded"
            />

          )}
          {shifts && users && users.length === 0 && (
            <Table
              filter={
                <RadioGroup
                  direction='horizontal'
                  items={[{ label: 'Todos', value: '0' }, { label: 'En venta', value: '1' }]}
                  value={filter}
                  onChange={(event) => {
                    setFilter(event.detail.value);
                  }}
                />
              }
              cellVerticalAlign='top'
              sortingDisabled
              columnDefinitions={[
                {
                  id: 'dateShift',
                  header: 'Turno',
                  minWidth: 100,
                  cell: (item) => item.dateShift,
                  sortingField: 'dateShift',
                },
                {
                  id: 'userDirector',
                  header: <FormField label='Mercenario'>Director</FormField>,
                  cell: (item) => item.isSelling === 1 ? <FormField label={item.user}><em>No adjudicado aun</em></FormField> : <FormField label={item.userMercenary}>
                    {item.user}
                  </FormField>,
                  sortingField: 'isSelling',
                },
                {
                  id: 'status',
                  header: 'Estado',
                  cell: (item) =>
                    <FormField constraintText={
                      item.isSelling == 1 && item?.jsonExchange.some((m: any) => m.idUser === idUser) ? "Participando" : ""

                    }>
                      {item.isSelling === 1 ? <BadgeCustom color='lime'>En venta</BadgeCustom> : <BadgeCustom color='green'>Vendido</BadgeCustom>}
                    </FormField>
                  ,
                  sortingField: 'isSelling',
                  minWidth: 120,
                },
                {
                  id: 'dateClose',
                  header: 'Cierre',
                  cell: (item) => <FormField label={format(parse(item.dateEndSelling, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>{format(parse(item.dateEndSelling, "dd-MM-yyyy HH:mm", new Date()), "HH:mm")}</FormField>,
                  sortingField: 'isSelling',
                  minWidth: 100,
                },
                {
                  id: 'mercenaries',
                  header: '',
                  cell: (item) => !item.jsonExchange || item.jsonExchange.length === 0 ? '---' : (

                    <Popover dismissButton={false} triggerType="custom"
                      header="Postulantes"
                      content={
                        <List
                          ariaLabel="Lista de mercenarios"
                          items={item.jsonExchange ? item?.jsonExchange?.map((m: any) => ({
                            id: String(m.idUser),
                            content: item.idUserMercenary !== m.idUser ? `${m.displayName}` : <SpaceBetween size='xs' direction='horizontal'><Icon path={mdiTrophyOutline} size={0.75} />{m.displayName}</SpaceBetween>
                          })) : []}
                          renderItem={(merc) => merc}
                        />
                      }
                    >
                      <Icon path={mdiAccountOutline} size={1} />x{item.jsonExchange.length}
                    </Popover>
                  ),
                  sortingField: 'isSelling',
                  minWidth: 50,
                },
                ...(showRegisterColumn
                  ? [{
                    id: 'register',
                    header: '',
                    minWidth: 180,
                    cell: (item: any) =>
                      item.isSelling === 1 ? (
                        item?.jsonExchange.some((m: any) => m.idUser === idUser) ? (
                          <Button onClick={() => handleRegisterMercenary(false, item.idShift)}><Icon path={mdiLocationExit} size={1} /></Button>
                        ) : item.idUserDirector !== idUser ?
                          <Button
                            variant="primary"
                            onClick={() => handleRegisterMercenary(true, item.idShift)}><Icon path={mdiLocationEnter} size={1} /></Button>
                          : null

                      ) : (
                        <>{""}</>
                      ),
                  }]
                  : [])
              ]}
              items={filteredShifts}
              stickyHeader
              variant="embedded"
              empty={
                <Box
                  margin={{ vertical: "xs" }}
                  textAlign="center"
                  color="inherit"
                >No hay turnos disponibles
                </Box>
              }
            />
          )}
        </SpaceBetween>
      }
    />
  );
};
